import produce from 'immer'
import { Reducer } from 'redux'

import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { SET_HOMEPAGE_ARTICLES, SET_NEWS_AOL } from 'redux/actions/types'
import { CAArticle } from 'interfaces/ca'

interface CAState {
  homepageArticles: number | CAArticle[]
  newsAol?: string
}

const initialState: CAState = {
  homepageArticles: RESPONSE_PENDING,
  newsAol: ''
}

const ca: Reducer<CAState, any> = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_NEWS_AOL:
      return produce(state, draft => {
        draft.newsAol = action.newsAol
      })
    case SET_HOMEPAGE_ARTICLES:
      return produce(state, draft => {
        draft.homepageArticles = action.homepageArticles
      })
    default:
      return state
  }
}

export default ca
